import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import { Constants } from "../../utils/Constants";
import Login from "./Login";

export default function AuthPage() {
    return (
        <div className="kt-grid kt-grid--ver kt-grid--root">
            <div id="kt_login" className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1">
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
                    <div className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside color-principal-100" style={{ backgroundColor: "#bfbfbf" }}>
                        <div className="kt-grid__item"></div>

                        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver" style={{ justifyContent: "center" }}>
                            <div className="kt-grid__item kt-grid__item--middle">
                                <img alt="Logo" src={toAbsoluteUrl("/images/logo-dark.png")} style={{ width: "300px" }} />
                            </div>
                        </div>

                        <div className="kt-grid__item" id="copyright-item">
                            <div className="kt-login__info">
                                <div className="kt-login__copyright">
                                    &copy;{new Date().getFullYear()}{" "}
                                    <a href={Constants.url} target="_blank" rel="noopener noreferrer" className="kt-login__copyright">
                                        Masi Negócios
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
                        <Switch>
                            <Route path="/auth/login" component={Login} />
                            <Redirect from="/auth" exact={true} to="/auth/login" />
                            <Redirect to="/auth/login" />
                        </Switch>
                        <div className="kt-grid__item" id="copyright-item-mobile">
                            <div className="kt-login__info">
                                <div className="kt-login__copyright">
                                    &copy;{new Date().getFullYear()}{" "}
                                    <a href={Constants.url} target="_blank" rel="noopener noreferrer" className="kt-login__copyright">
                                        Masi Negócios
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
